import { render, staticRenderFns } from "./DashboardUserInfo.vue?vue&type=template&id=cf222b80&scoped=true"
import script from "./DashboardUserInfo.vue?vue&type=script&lang=js"
export * from "./DashboardUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf222b80",
  null
  
)

export default component.exports